import { __assign } from "tslib";
import React, { useRef } from 'react';
import { useDebugRerenders } from '@wix/da-hooks/pkg/useDebugRerenders';
import Torpedo from '../BaseTorpedo';
import { useMeasuredCookie } from '../../Measured/useMeasuredCookie';
function getMeasuredContainer(containerFromProps, measuredContainer) {
    var _a;
    return {
        width: Number((_a = measuredContainer === null || measuredContainer === void 0 ? void 0 : measuredContainer.width) !== null && _a !== void 0 ? _a : containerFromProps.width),
    };
}
var MeasuredTorpedo = function (props) {
    var containerRef = useRef(null);
    var sentinelRef = useRef(null);
    var measuredContainer = useMeasuredCookie(props.cookieType, containerRef, {
        cookieDim: 'width',
        defaultSize: props.defaultSize,
        listenOnWindow: true,
        sentinelRef: sentinelRef,
    });
    useDebugRerenders('MeasuredTorpedo', __assign(__assign({}, props), { measuredContainer: measuredContainer }));
    var container = getMeasuredContainer(props.container, measuredContainer);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: sentinelRef, style: { maxWidth: '100%' } }),
        React.createElement("div", { ref: containerRef },
            React.createElement(Torpedo, __assign({}, props, { container: container })))));
};
MeasuredTorpedo.displayName = 'MeasuredTorpedo';
export default MeasuredTorpedo;
//# sourceMappingURL=MeasuredTorpedo.js.map